import React, { useState } from 'react'
import './PackList.css' // Importar o arquivo CSS
import Navbar from '../../components/navbar/navbar'
import { now } from 'moment'
import apinode from '../../services/apinode'

const PackList = () => {
  const [items, setItems] = useState([])
  // const [items, setItems] = useState([
  //     { id: 1, descricao: 'Item 1', quantidade: 3, numeroPedido: '12345', origem: 'Mercado Livre', conferido: false },
  //     { id: 2, descricao: 'Item 2', quantidade: 2, numeroPedido: '12346', origem: 'Shopee', conferido: true },
  //     { id: 3, descricao: 'Item 1', quantidade: 1, numeroPedido: '12345', origem: 'Mercado Livre', conferido: false },
  //     // Adicione mais itens conforme necessário
  // ]);

  const fetchItems = async () => {
    try {
      const response = await apinode.get(
        `/packlist/${now}/${localStorage.idconta}`,
      )
      setItems(response.data) // Atualize o estado com os dados recebidos
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
    }
  }

  const [searchText, setSearchText] = useState('')
  const [searchDate, setSearchDate] = useState('')

  // Função para alternar o estado de conferido de um item
  const toggleConferido = (id) => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, conferido: !item.conferido } : item,
      ),
    )
  }

  // Função para imprimir a lista de pedidos conferidos
  const imprimirPedidosConferidos = () => {
    const pedidosConferidos = items.filter((item) => item.conferido)
    console.log('Imprimir pedidos conferidos:', pedidosConferidos)
    // Lógica de impressão aqui (pode variar dependendo do ambiente)
  }

  // Função para visualizar pedidos conferidos
  const visualizarPedidosConferidos = () => {
    const pedidosConferidos = items.filter((item) => item.conferido)
    console.log('Visualizar pedidos conferidos:', pedidosConferidos)
    // Lógica de visualização aqui
  }

  // Função para filtrar os itens com base no texto de pesquisa e na data
  const filterItems = () => {
    // Lógica de filtragem com base em searchText e searchDate
    // Atualize o estado dos itens filtrados
    // Por exemplo:
    // const filteredItems = items.filter((item) => {
    //     const searchTextMatch = item.descricao.toLowerCase().includes(searchText.toLowerCase());
    //     const dateMatch = searchDate === '' || item.numeroPedido === searchDate; // Supondo que numeroPedido seja a data
    //     return searchTextMatch && dateMatch;
    // });
    // Atualize o estado dos itens filtrados
    fetchItems()
    // setItems(pack);
  }

  return (
    <>
      <Navbar />

      <div className="container-fluid mt-page form-pedido-editar">
        <h1>Lista de Separação de Pedidos</h1>
        <div className="search-container">
          <input
            type="text"
            placeholder="Pesquisar por descrição"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <input
            type="date"
            placeholder="Pesquisar por data"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
          />
          <button onClick={filterItems}>Pesquisar</button>
        </div>
        <div className="pack-list-container">
          <div className="table-container">
            <table className="ui table ui striped table">
              <thead>
                <tr>
                  <th style={{ verticalAlign: 'middle' }}>Descrição</th>
                  <th style={{ verticalAlign: 'middle' }}>Número do Pedido</th>
                  <th style={{ verticalAlign: 'middle' }}>Origem</th>
                  <th style={{ verticalAlign: 'middle' }}>Quantidade Total</th>
                  <th style={{ verticalAlign: 'middle' }}>Conferido</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.descricao}</td>
                    <td>{item.numeroPedido}</td>
                    <td>{item.origem}</td>
                    <td>{item.quantidade}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={item.conferido}
                        onChange={() => toggleConferido(item.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="footer-buttons">
            <button onClick={visualizarPedidosConferidos}>
              Visualizar Pedidos Conferidos
            </button>
            <button onClick={imprimirPedidosConferidos}>
              Imprimir Pedidos Conferidos
            </button>
            <button>Imprimir por Pedido</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default PackList
